import React from 'react';
import '../../../../shared/promptForm/components/FormInput.css';

const BackgroundTheoryInput = ({ value, onChange }) => {
  return (
    <div className="form-input-group full-width">
      <label className="form-label">Background theory (optional)</label>
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="form-textarea"
        placeholder="Provide background theory or context for the prompt"
        rows="4"
      />
    </div>
  );
};

export default BackgroundTheoryInput;

